import { Alert, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledAlert = styled(Alert) `
  margin-top: ${theme.spacing.xl};
`;
